__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "@amzn/my-hr-ai-assistant-ui";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("react-dom", "17.0.2", () => (Promise.all([__webpack_require__.e(961), __webpack_require__.e(1502), __webpack_require__.e(5228)]).then(() => (() => (__webpack_require__(40961))))));
			register("react-router-dom", "5.3.4", () => (Promise.all([__webpack_require__.e(876), __webpack_require__.e(668), __webpack_require__.e(6158)]).then(() => (() => (__webpack_require__(30876))))));
			register("react", "17.0.2", () => (__webpack_require__.e(6540).then(() => (() => (__webpack_require__(96540))))));
			register("single-spa-react/parcel", "5.1.4", () => (Promise.all([__webpack_require__.e(4651), __webpack_require__.e(8848)]).then(() => (() => (__webpack_require__(18848))))));
			register("single-spa-react", "5.1.4", () => (__webpack_require__.e(5684).then(() => (() => (__webpack_require__(5684))))));
		}
		break;
		case "stencil@4": {
			register("@amzn/stencil-react-desc", "4.19.0", () => (__webpack_require__.e(3530).then(() => (() => (__webpack_require__(93530))))));
			register("@amzn/stencil-react-icons", "4.19.0", () => (Promise.all([__webpack_require__.e(2020), __webpack_require__.e(1238), __webpack_require__.e(5447), __webpack_require__.e(2106), __webpack_require__.e(70), __webpack_require__.e(9538)]).then(() => (() => (__webpack_require__(99538))))));
			register("@amzn/stencil-react-theme-default", "4.19.0", () => (Promise.all([__webpack_require__.e(5690), __webpack_require__.e(5447)]).then(() => (() => (__webpack_require__(95690))))));
			register("@amzn/stencil-react-utils", "4.19.0", () => (Promise.all([__webpack_require__.e(2020), __webpack_require__.e(2612)]).then(() => (() => (__webpack_require__(42612))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};